
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.525 14.295A11.029 11.029 0 016.3 12.846c1-.354 2.067-.531 3.2-.531s2.2.177 3.2.531c1 .354 1.925.837 2.775 1.449A7.724 7.724 0 0016.95 12c.367-.87.55-1.811.55-2.825 0-2.141-.779-3.965-2.337-5.47C13.604 2.2 11.717 1.449 9.5 1.449S5.396 2.2 3.838 3.706C2.279 5.21 1.5 7.035 1.5 9.176c0 1.014.183 1.956.55 2.825.367.87.858 1.634 1.475 2.294zM9.5 9.9c-.917 0-1.687-.302-2.312-.906-.625-.603-.938-1.348-.938-2.233s.313-1.63.938-2.233c.625-.604 1.395-.906 2.312-.906.917 0 1.687.302 2.312.906.625.603.938 1.348.938 2.233s-.313 1.63-.938 2.233c-.625.604-1.395.906-2.312.906zm0 8.452a9.545 9.545 0 01-3.712-.725 9.606 9.606 0 01-3.013-1.956 9.242 9.242 0 01-2.025-2.91A8.685 8.685 0 010 9.176c0-1.272.25-2.467.75-3.587A9.245 9.245 0 012.775 2.68 9.607 9.607 0 015.788.724 9.546 9.546 0 019.5 0c1.317 0 2.554.241 3.713.724a9.61 9.61 0 013.012 1.956 9.245 9.245 0 012.025 2.91c.5 1.119.75 2.314.75 3.586 0 1.271-.25 2.467-.75 3.585a9.242 9.242 0 01-2.025 2.91 9.609 9.609 0 01-3.012 1.956 9.552 9.552 0 01-3.713.725zm0-1.45c.9 0 1.771-.14 2.613-.422a7.598 7.598 0 002.237-1.17 7.794 7.794 0 00-2.213-1.136 8.319 8.319 0 00-2.637-.41c-.933 0-1.812.133-2.637.399a7.238 7.238 0 00-2.213 1.146c.65.5 1.396.89 2.237 1.17a8.173 8.173 0 002.613.424zm0-8.45c.5 0 .917-.162 1.25-.484.333-.322.5-.724.5-1.207a1.61 1.61 0 00-.5-1.207c-.333-.322-.75-.483-1.25-.483s-.917.16-1.25.483a1.61 1.61 0 00-.5 1.207c0 .483.167.885.5 1.207.333.322.75.483 1.25.483z","fill":"#fff"}})])
          )
        }
      }
    